import { Authorization } from 'glxl-helpers';

import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';
import apiCall from '../apiCall';

const auth = new Authorization();

export default class SoftwareGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.icons = [icons.testen];
    this.handleClick = async () => {
      console.log(props.item);
      if (typeof props.item.Game === 'object') {
        const { softwareLocation, seriousGamesSoftwareLocation } = props.item.Game;
        if (props.item.category === "software_testen") {
          if (props.item.Game.isSeriousGamesMinigame) {
            window.open(`${seriousGamesSoftwareLocation}test/${props.item.Game.abbreviation}`, '_blank');
          } else {
            window.open(`${softwareLocation}`, '_blank');
          }
          return;
        }
        if (props.item.Game.isSeriousGamesMinigame) {
          window.open(`${props.item.Game.seriousGamesSoftwareLocation}?token=${encodeURIComponent((await apiCall('/seriousgames/gamemasterLoginToken', { minigame: props.item.Game.abbreviation }, 'POST')).token)}`);
          return;
        }
        if (props.item.Game.id === 5) { // Filmquiz
          const filmquizData = await apiCall(`/filmQuiz/${props.schoolClass.id}`);
          if (filmquizData.beamerIsOpen) {
            props.showPopup('dhbmfilmquiz_software', (result) => {
              if (result) {
                window.open(`${softwareLocation}${(props.item.dontLogin ? '' : `?token=${auth.getAuthToken()}`)}`, '_blank');
              }
            });
            return;
          }
        }
        window.open(`${softwareLocation}${(`?token=${auth.getAuthToken()}`)}`, '_blank');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/SoftwareGameMaterial.js